type Provider = "plausible" | "umami" | "";

const PROVIDER = (process.env.NEXT_PUBLIC_ANALYTICS_PROVIDER as Provider) || "";

declare global {
  interface Window {
    plausible?: (
      event: string,
      opts?: { props?: Record<string, unknown> },
    ) => void;
    umami?: {
      track?: (event: string, data?: Record<string, unknown>) => void;
      trackEvent?: (event: string, data?: Record<string, unknown>) => void;
    };
  }
}

export function track(event: string, props?: Record<string, unknown>) {
  if (typeof window === "undefined" || !PROVIDER) return;
  try {
    if (PROVIDER === "plausible") {
      window.plausible?.(event, props ? { props } : undefined);
    } else if (PROVIDER === "umami") {
      if (typeof window.umami?.track === "function")
        window.umami.track(event, props);
      else if (typeof window.umami?.trackEvent === "function")
        window.umami.trackEvent(event, props);
    }
  } catch {
    // no-op
  }
}

// Domain events
export function trackViewItem(input: {
  id: string;
  slug: string;
  title: string;
}) {
  track("VIEW_ITEM", input);
}

export function trackAddToCart(input: {
  variantId: string;
  variantSlug: string;
  productTitle: string;
  variantTitle: string;
  priceCents: number;
  currency: string;
  quantity: number;
}) {
  track("ADD_TO_CART", input);
}

export function trackBeginCheckout(input: {
  totalCents: number;
  currency: string;
  items: Array<{ variantId: string; quantity: number }>;
}) {
  track("BEGIN_CHECKOUT", input);
}

export function trackPurchase(input: {
  sessionId?: string | null;
  totalCents?: number;
  currency?: string;
}) {
  track("PURCHASE", input);
}

export function trackSelectPickup(location: string) {
  track("SELECT_PICKUP", { location });
}

export function trackSelectShip(method: string) {
  track("SELECT_SHIP", { method });
}
